module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00727.e9839dff.jpg";